<ng-progress [ease]="'linear'" [spinner]="false" (completed)="completed()" (started)="started()"></ng-progress>
<!-- <div *ngIf="isLoaderRemoved" data-cy="loader-element"></div> -->
<app-loader-fullscreen></app-loader-fullscreen>
<router-outlet></router-outlet>
